import { NutriscoreContext } from 'context/nutriscoreLabelContext';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import 'components/desktop/_general/NutriScoreDiagram/NutriScoreDiagram.scss';
import { NutriScore } from 'types/_general/NutriScore';

interface IProps {
	nutriScore: NutriScore | null;
}

const NutriScoreDiagram = (props: IProps) => {
	const { t } = useTranslation();
	const labels = useContext(NutriscoreContext);
	const labelList = labels.nutriscoreLabels.map((x) => x.label).distinct();

	function useMediaQuery(query: string) {
		const [matches, setMatches] = useState(() =>
			typeof window !== 'undefined' ? window.matchMedia(query).matches : false
		);

		useEffect(() => {
			const media = window.matchMedia(query);
			if (media.matches !== matches) {
				setMatches(media.matches);
			}
			const listener = () => setMatches(media.matches);
			media.addEventListener('change', listener);
			return () => media.removeEventListener('change', listener);
		}, [query, matches]);

		return matches;
	}

	const isDesktop = useMediaQuery('(min-width:1024px)');

	const renderLabel = (label: string, key: number): JSX.Element => {
		if (label == props.nutriScore?.label) {
			return (
				<div
					className="nutri-score-diagram-score score"
					style={{ backgroundColor: props.nutriScore.color }}
					key={key}
				>
					<span className="nutri-score-label">{label}</span>
				</div>
			);
		} else {
			if(isDesktop) return (
				<div className="nutri-score-diagram-score score" key={key}>
					<span className="nutri-score-label">{label}</span>
				</div>
			);
			return <></>
		}
	};

	return (
		<div className="nutri-score-diagram-container-outer d-flex align-items-center">
			<label style={{color: 'white', marginRight: '0.5rem'}}>{t('_general:NUTRI_SCORE')}:</label>
			<div className="nutri-score-diagram-container-inner">
				{labelList.map((l: string, key: number) => renderLabel(l, key))}
			</div>
		</div>
	);
};

export default NutriScoreDiagram;
